<script lang="ts">
	import Star from 'assets/svg/star.svg?url';
	import StarDark from 'assets/svg/starDark.svg?url';
	import StarWhite from 'assets/svg/starWhite.svg?url';
	import StarWhiteLight from 'assets/svg/starWhiteLight.svg?url';
	import userStore from 'stores/user';
	import { upsertWatchlist } from 'utils/watchlist/upsert';

	export let dark: boolean;
	export let id;

	let isInWatchlist = false;
	let watchlistData;

	const fetchList = () => {
		if ($userStore._id?.length > 0) {
			watchlistData = $userStore?.watchlist['Main watchlist'];
			isInWatchlist = watchlistData?.includes(id);
		}
	};

	const handleWatchlist = () => {
		let returnArr = watchlistData;
		if ($userStore?._id.length > 0) {
			if (returnArr.includes(id)) {
				let index = returnArr.indexOf(id);
				if (index > -1) {
					returnArr.splice(index, 1);
				}
				isInWatchlist = false;
			} else {
				returnArr.push(id);
				isInWatchlist = true;
			}
			upsertWatchlist($userStore._id, returnArr);
		}
	};

	$: $userStore, fetchList();
</script>

{#if $userStore?._id?.length > 0}
	{#key isInWatchlist}
		<div class="wrapper center" class:dark on:click={handleWatchlist}>
			<img
				src={dark ? (isInWatchlist ? StarWhite : StarWhiteLight) : isInWatchlist ? StarDark : Star}
				class="icon-star center"
				alt=""
				width="18"
				height="18"
			/>
			<p class="add-text">{isInWatchlist ? '- Remove from watchlist' : '+ Add to watchlist'}</p>
		</div>
	{/key}
{/if}

<style lang="scss">
	@import 'addToWatchList';
</style>
